export enum ApCurrency {
	INR = 'inr',
	USD = 'usd',
	GBP = 'gbp',
	EUR = 'eur',
	UNKNOWN = ''
}
